import React from 'react';
import styled from 'styled-components';
import { Button } from '@hotelplan/components.common.buttons';
import { WhiteBoxModal } from '@hotelplan/components.common.modals';
import { OrlFlightAlternative } from '@hotelplan/graphql.types';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import { mapOrlFlightToIFlightSectionProps } from 'components/domain/orl/Orl.mappers';
import FlightItem from './FlightItem';

const FlightStopsOverlayWrap = styled.div.attrs({
  className: 'flight-stops-overlay',
})(
  sx2CssThemeFn({
    pt: [4, 0],
    width: ['100%', '550px'],
    position: ['relative', 'absolute'],
    bottom: [null, 4],
    right: [null, '50%'],
    transform: [null, 'translateX(50%)'],
    backgroundColor: 'white',
    zIndex: 10,
    textShadow: 'none',
    border: '1px solid #999999',
    borderRadius: [null, 'default'],
    boxShadow: [null, '0px 1px 7px rgba(0, 0, 0, 0.5)'],
    '.tagline-text': {
      marginBottom: 3,
      color: 'secondary',
      fontSize: '26px',
      lineHeight: '1',
    },
    '.input-wrap .label': {
      fontSize: 0,
      mb: 2,
      color: 'textGray',
      pl: 0,
      span: {
        color: 'inherit',
      },
    },
  })
);

const ModalCloseButton = styled(Button).attrs({
  variant: 'iconBtn',
  icon: { name: 'close' },
  'data-id': `close`,
})(
  sx2CssThemeFn({
    position: 'absolute',
    top: [2, 1],
    right: [2, 1],
    backgroundColor: 'inherit',
    '.icon': {
      variant: ['icons.md', 'icons.sm'],
    },
  })
);

interface IFlightStopsOverlayProps {
  onClose?(): void;
  flight?: OrlFlightAlternative;
  refValue?: any;
}

const FlightStopsOverlay: React.FC<IFlightStopsOverlayProps> = ({
  onClose,
  flight,
  refValue,
}) => {
  const { mobile } = useDeviceType();

  function renderFlightStops() {
    return (
      <FlightStopsOverlayWrap ref={refValue}>
        <FlightItem
          {...mapOrlFlightToIFlightSectionProps(flight.outboundFlight)}
        />
        <FlightItem
          {...mapOrlFlightToIFlightSectionProps(flight.inboundFlight)}
          isReturnFlight
        />
        <ModalCloseButton onClick={onClose}>{`Close window`}</ModalCloseButton>
      </FlightStopsOverlayWrap>
    );
  }

  return (
    <>
      {mobile ? (
        <WhiteBoxModal name={'flight-stops-modal'} show title={''}>
          {renderFlightStops()}
        </WhiteBoxModal>
      ) : (
        <>{renderFlightStops()}</>
      )}
    </>
  );
};

export default React.memo(FlightStopsOverlay);
